import { restore, sample } from 'effector'
import { fx } from '../../../../../libs'
import { $generateBalanceFilter } from '../generalBalanceFilter/model'
import { ActiveBalancesData } from './types'
import {
  $activeBalanceFilter,
  setActiveBalanceFilter,
} from '../activeBalanceFilter/model'

const defaultActiveBalancesData: ActiveBalancesData = {
  openingBalance: 0,
  turnover: {
    value: 0,
    deposit: 0,
    withdrawal: 0,
  },
  liabilities: {
    value: 0,
    budgetPayment: 0,
    otherPayment: 0,
    dividend: 0,
  },
  investment: 0,
  earning: 0,
  costs: {
    value: 0,
    transactionCommission: 0,
    paymentCommission: 0,
    commission: 0,
  },
  debt: 0,
  lpBalance: {
    value: 0,
    lpInvest: 0,
    lpTrade: 0,
    lpReturn: 0,
  },
  transfers: {
    value: 0,
    inInt: 0,
    outInt: 0,
  },
  inProgress: {
    openingBalance: 0,
    finalBalance: 0,
  },
  exchangeDifference: 0,
  finalBalanceUsd: 0,
  balanceChange: 0,
}

const mergeActiveBalancesData = (
  receivedData: Partial<ActiveBalancesData> | null,
): ActiveBalancesData => {
  if (!receivedData) {
    return { ...defaultActiveBalancesData }
  }

  const mergedData: ActiveBalancesData = { ...defaultActiveBalancesData }

  for (const key in receivedData) {
    if (receivedData.hasOwnProperty(key)) {
      const value = receivedData[key as keyof ActiveBalancesData]
      const defaultValue =
        defaultActiveBalancesData[key as keyof ActiveBalancesData]

      if (
        typeof defaultValue === 'object' &&
        defaultValue !== null &&
        !Array.isArray(defaultValue) &&
        typeof value === 'object' &&
        value !== null &&
        !Array.isArray(value)
      ) {
        mergedData[key as keyof ActiveBalancesData] = {
          ...(defaultValue as object),
          ...(value as object),
        } as any
      } else if (value !== undefined) {
        mergedData[key as keyof ActiveBalancesData] = value as any
      }
    }
  }

  return mergedData
}

export const getActiveBalances = fx<void, ActiveBalancesData | null>({
  method: 'GET',
  url: `/finance/balance-summary-active`,
})

export const $activeBalances = restore<ActiveBalancesData>(
  getActiveBalances.doneData.map((a) => mergeActiveBalancesData(a.body)),
  { ...defaultActiveBalancesData },
)

sample({
  // @ts-ignore
  clock: setActiveBalanceFilter,
  source: {
    generateBalanceFilter: $generateBalanceFilter,
    activeBalanceFilter: $activeBalanceFilter,
  },
  fn: ({ generateBalanceFilter, activeBalanceFilter }) => {
    const { date } = generateBalanceFilter
    const { paymentSystem, activeBalanceCountries } = activeBalanceFilter

    const query = {}
    const requestObj: any = {}

    if (!date.dateFrom && !date.dateTo) {
      const currentDate = new Date()
      requestObj['dateFrom'] = `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1
      }-01`
      requestObj['dateTo'] = `${currentDate.getFullYear()}-${
        currentDate.getMonth() + 1
      }-${currentDate.getDate()}`
    }
    if (date.dateFrom) {
      requestObj['dateFrom'] = date.dateFrom
    }
    if (date.dateTo) {
      requestObj['dateTo'] = date.dateTo
    }
    if (activeBalanceCountries.length > 0) {
      requestObj['country'] = activeBalanceCountries
    }
    if (paymentSystem) {
      requestObj['paymentSystemId'] = paymentSystem
    }

    //@ts-ignore
    query['where'] = `${JSON.stringify(requestObj)}`

    return {
      query,
    }
  },
  target: getActiveBalances,
})
